import type { CycleEvaluatorSelection } from '@/types/cycle-evaluation/CycleEvaluatorSelection';

import { api } from '@/api/api';

export default {
    async updateCycleEvaluatorSelection(
        cycleEvaluatorSelection: CycleEvaluatorSelection,
    ): Promise<CycleEvaluatorSelection> {
        const response = await api.put<CycleEvaluatorSelection>(
            `/cycleevaluatorselection/${cycleEvaluatorSelection.id}`,
            cycleEvaluatorSelection,
        );

        return response.data;
    },
};
